var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('h2',{staticClass:"text__main-title text--centered text--bold append-dot"},[_vm._v(" "+_vm._s(_vm.$t('letter_is_sent'))+" ")]),_c('p',{staticClass:"text--centered"},[_vm._v(_vm._s(_vm.$t('email_confirmation', { email: _vm.email })))])])
}
var staticRenderFns = []

export { render, staticRenderFns }